module.exports = __webpack_public_path__ + "img/icon-address-large.b2781102.png";